import { ButtonHTMLAttributes } from "react";
import styles from "./Button.module.scss";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className: string;
};

export const Button = ({ children, className, ...rest }: ButtonProps) => {
  return (
    <button className={styles[className]} {...rest}>
      {children}
    </button>
  );
};
